<template>
  <div class="table">
    <el-table
      :data="allLeavesData"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text="You are yet to create a leave setting"
      :cell-class-name="tableCellClassName"
      @cell-click="cellClick"
      v-loading="loading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        sortable
        prop="id"
        label="ID"
        width="80"
      ></el-table-column>
      <el-table-column
        sortable
        prop="employee_name"
        label="EMPLOYEE NAME"
      ></el-table-column>
      <el-table-column
        sortable
        prop="leave_type_name"
        label="LEAVE TYPE"
        width="200"
      ></el-table-column>
      <el-table-column
        sortable
        prop="start_date"
        label="START DATE"
      ></el-table-column>
      <el-table-column
        sortable
        prop="end_date"
        label="END DATE"
      ></el-table-column>
      <el-table-column sortable prop="relief" label="RELIEF"></el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="STATUS"
        width="150"
      ></el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template slot-scope="scope">
          <div class="actions relative">
            <el-dropdown>
              <span class="el-dropdown-link">
                <img src="/img/more.svg" alt="view" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="$emit('toggleView', scope.row)"
                  >View</el-dropdown-item
                >
                <el-dropdown-item @click="edit(scope.row.id)"
                  >Edit</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="changeLeaveTypeStatus(scope.row)"
                  >{{ scope.row.status }}</el-dropdown-item
                >
                <el-dropdown-item
                  class="danger"
                  @click.native.prevent="deleteLeave(scope.row)"
                  >Delete</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  mounted() {
    this.getAllLeaves();
  },
  computed: {
    ...mapState({
      allLeavesData: "leavesData",
      total: "totalLeaveApprover",
      loading: "tableLoading",
      perPage: "perPage",
    }),
    currentPage: {
      get() {
        return this.$store.state.admin.hrm.leave.currentPage;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/currentPage", value);
      },
    },
  },
  methods: {
    ...mapActions([
      "handleSizeChange",
      "handleCurrentChange",
      "deleteLeave",
      "changeLeaveStatus",
    ]),
    getAllLeaves() {
      this.$store
        .dispatch("admin/hrm/leave/getAllLeaves")
        .then(() => {})
        .catch(error => {
          this.$notification("error", error.message, { offset: 100 });
        });
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    toggleView() {
      this.$emit("toggleView");
    },
    edit(id) {
      this.$router.push({ name: "edit-leave", params: { id } });
    },
    tableCellClassName({ row, column }) {
      if (row.status === "Approved" && column.property === "status") {
        return "approved";
      } else if (row.status === "Pending" && column.property === "status") {
        return "pending";
      }
      return "";
    },
    cellClick(row, column, cell) {
      const theCell = cell.querySelector(".more-actions");
      if (!theCell) return;
      theCell.classList.toggle("show");
    },
    changeLeaveTypeStatus(row) {
      const endpoint = row.status === "Active" ? "deactivate" : "activate";
      this.changeStatus([row.id], endpoint);
    },
    deleteLeave(row) {
      const id = [row.id];
      this.$promptModal(
        this,
        "Delete Leave",
        "This Leave will be deleted",
        "Delete",
        () => this.handleDeleteLeave(id)
      );
    },
    handleDeleteLeave(id) {
      this.loading = true;
      this.deleteLeave(id)
        .then(response => {
          this.$notification("success", response.message);
          this.loading = false;
          this.getAllLeaves();
        })
        .catch(error => {
          this.loading = false;
          this.$notification("error", error.message);
        });
    },
  },
};
</script>
